import DealerOrderPanel from "./dealerOrderPanel.container"

export default DealerOrderPanel
